import * as React from "react";

const wrapPageElement = ({ element, props }) => {
    return <div {...props}>{element}</div>;
};

export { wrapPageElement };
